export const RATE_MIN_VALUE = 0
export const RATE_MAX_VALUE = 9999
